import Destination1 from '../assets/penang.jpg';
import Destination2 from "../assets/penang_and_phuket.avif";
import Destination3 from "../assets/phooketovernight.jpg";
// import Destination4 from "../assets/vietman.avif";
import Destination4 from "../assets/beachlombok.avif";

const packagedata = [

    {
        Nights: '3 Nights Cruise',
        Destination : 'Visit Penang',
        DestinationImage : Destination1,
        link: 'https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&durations=1-3&DeparturePorts=SIN&sortColumn=cruiselinePriority&sortOrder=asc'
    },
    {
        Nights: '4 Nights Cruise',
        Destination : 'Visit Penang and Phuket',
        DestinationImage : Destination2,
        link : 'https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&durations=4-6&DeparturePorts=SIN&sortColumn=departureDate&sortOrder=asc'
    },
    {
        Nights: '5 Nights Cruise',
        Destination : 'Visit Penang and Phuket (Overnight)',
        DestinationImage : Destination3,
        link : "https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&durations=4-6&DeparturePorts=SIN&sortColumn=departureDate&sortOrder=asc"
    },
    {
        Nights: '8 Nights Cruise',
        Destination : 'Visit Celukan Bawang, Benoa Bali, Lombok', 
        DestinationImage : Destination4,
        link :'https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&Ship=13717&DeparturePorts=SIN&durations=7-9&sortColumn=cruiselinePriority&sortOrder=asc'
    },

]

export default packagedata;

